<!--  -->
<template>
  <div class="v1">
    <img
      src="~@/assets/images/ad/ad2/active-20220816.png"
      alt=""
      class="v1_img"
    />
    <img
      src="~@/assets/images/ad/ad2/active-20220816-1.png"
      alt=""
      class="v1_img1"
    />
    <div class="v1_1">活动时间：8月19日-9月18日</div>
    <div class="v1_2" @click="onReceive">
      {{ isHasReceive === 1 ? "已领取" : "立即填写，领券享现结" }}
    </div>
    <div class="v1_3">
      <p class="v1_3_1">活动规则</p>
      <p class="v1_3_2">
        1.本次活动仅面向2022年8月19日之前在神州邦邦平台完成注册，但接单技能或接单偏好仍未完善的用户。
      </p>
      <p class="v1_3_2">
        2.用户通过本活动页面完成接单技能和技能偏好信息填写并通过验证，即可获得1000元额度现结券一张，现结券有效期：30天，可在个人中心-我的卡券中查看。
      </p>
      <p class="v1_3_2">
        3.现结券可用于不大于1000元的订单，申请提现时勾选使用现结券即可使用，提现后3个工作日内到账，大于等于1000元的订单页面不显示现结券。
      </p>
      <p class="v1_3_2">
        4.每张现结券仅可使用1次，不支持多笔订单合并使用1张券，不支持1张现结券拆分多次使用。
      </p>
      <p class="v1_3_2">5.如有本活动其他相关问题，请咨询：400-676-3988。</p>
    </div>
  </div>
</template>

<script>
import { post, get, initLogin } from "@/utils/request3";
import { api } from "@/utils/env";
import { Toast, Dialog } from "vant";
import wx from "@/assets/js/jweixin-1.6.0";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      isHasReceive: 0,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    onReceive() {
      if (this.isHasReceive === 1) {
        Toast("您已经领取过了!");
        return;
      }
      get({
        url: api + "server/engineer/refineInfo",
        data: {},
        requestType: 2,
        loginSuccess: () => {
          this.onReceive();
        },
      })
        .then((data) => {
          if (data.result === "success") {
            if (
              data.body.isRefineSkill === 1 &&
              data.body.isRefineWorkArea === 1
            ) {
              return post({
                url: api + "bangActivity/receiveWithdrawCoupon",
                data: {},
                requestType: 2,
              });
            } else {
              this.$router.push({
                name: "20220816-next.html",
              });
            }
          } else {
            Toast(data.message);
          }
        })
        .then((data) => {
          if (data.result === "success") {
            Dialog.confirm({
              title: "恭喜您",
              message: "领券成功！快去接单使用吧",
              confirmButtonText: "立刻接单",
              cancelButtonText: "关闭",
            })
              .then(() => {
                wx.miniProgram.switchTab({
                  url: `/pages/market/market`,
                });
              })
              .catch(() => {
                // on cancel
              });
            this.isHasReceive = 1;
          } else {
            Toast(data.message);
          }
        })
        .catch(() => {});
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    initLogin({
      needLoginModal: false,
      success: () => {
        get({
          url: api + "bangActivity/refineActivityInfo",
          data: {},
          requestType: 1,
        })
          .then((data) => {
            if (data.result === "success") {
              this.isHasReceive = data.body.isHasReceive;
            } else {
              Toast(data.message);
            }
          })
          .catch(() => {});
      },
    });
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    $("body").css({
      backgroundColor: "#FFA65E",
      position: "relative",
    });
  },
  beforeCreate() {
    $("body").css({
      backgroundColor: "#FFA65E",
      position: "relative",
    });
  }, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {
    $("body").css({
      backgroundColor: "#FFA65E",
      position: "relative",
    });
  }, //生命周期 - 更新之后
  beforeDestroy() {
    $("body").removeAttr("style");
  }, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.v1_img1 {
  width: 7.5rem;
  height: 1.88rem;
  margin: 0 auto -0.3rem;
}
.v1 {
  width: 7.5rem;
  min-height: 100vh;
  margin: 0 auto;
  position: relative;
  padding-bottom: 1.5rem;
  .v1_img {
    width: 7.5rem;
    height: 11.23rem;
  }
  .v1_img1 {
    width: 7.5rem;
    height: 1.88rem;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
  }
  .v1_1 {
    font-size: 0.24rem;
    color: #fff;
    text-align: center;
    position: absolute;
    left: 0;
    right: 0;
    top: 1.68rem;
  }
  .v1_2 {
    width: 5rem;
    height: 1rem;
    background: linear-gradient(180deg, #fdf2c2 0%, #fcaa59 100%);
    box-shadow: 0px 0.02rem 0.2rem 0px #de0000;
    border-radius: 0.5rem;
    line-height: 1rem;
    text-align: center;
    color: #fe3b3b;
    font-weight: bolder;
    font-size: 0.36rem;
    position: absolute;
    top: 6.6rem;
    left: 0;
    right: 0;
    margin: auto;
  }
  .v1_2_1 {
    animation: heart 1s linear infinite;
  }
  .v1_3 {
    position: absolute;
    width: 5.8rem;
    overflow: hidden;
    height: auto;
    top: 9.3rem;
    left: 0.84rem;
    right: 0.84rem;
    margin: auto;
    color: #fff;
    .v1_3_1 {
      font-size: 0.2rem;
      font-weight: bolder;
      line-height: 0.4rem;
    }
    .v1_3_2 {
      font-size: 0.18rem;
      line-height: 0.34rem;
    }
  }
}
@keyframes heart {
  0% {
    transform: scale(1, 1);
  }
  25% {
    transform: scale(1.1, 1.1);
  }
  100% {
    transform: scale(1, 1);
  }
}
</style>